import { PaletteOptions } from '@mui/material';

const palette: PaletteOptions = {
  primary: {
    light: '#757ce8',
    main: '#3f50b5',
    dark: '#002884',
    contrastText: '#fff',
  },
  error: {
    main: '#d63031',
    contrastText: '#fff',
  },
  secondary: {
    main: '#656565',
    dark: '#6c6b6b',
    light: '#f3f2f1',
    contrastText: '#fff',
  },

  warning: {
    main: '#F3B238',
    light: '#FCD285',
    dark: '#F7A712',
    contrastText: '#fff',
  },

  success: {
    main: '#2E7D32',
  },
};

export default palette;
